export default __webpack_public_path__ + "static/media/houimg1.6342d8db.webp";